import { getUrlParams } from '@/common/miscutil'
import {userAgentUtil} from "jscom/utils/UserAgentUtil"
import { isDev, isPre } from '@/common/env'
import { CacheUtil } from '@/common/cacheUtil'
import { MutationTypes } from 'buyerapp/store/mutation-types'

class WxCallbackObject {
  constructor () {
    this.status = ''
    this.value = null
    this.message = ''
  }

  static getNoReady () {
    let wxcbObject = new WxCallbackObject()
    wxcbObject.status = 'noReady'
    wxcbObject.message = 'wx sdk is not ready'
    return wxcbObject
  }

  static getSuccess (value, message) {
    let wxcbObject = new WxCallbackObject()
    wxcbObject.status = 'success'
    wxcbObject.value = value
    wxcbObject.message = message
    return wxcbObject
  }

  static getCancel (value, message) {
    let wxcbObject = new WxCallbackObject()
    wxcbObject.status = 'cancel'
    wxcbObject.value = value
    wxcbObject.message = message
    return wxcbObject
  }

  static getError (value, message) {
    let wxcbObject = new WxCallbackObject()
    wxcbObject.status = 'error'
    wxcbObject.value = value
    wxcbObject.message = message
    return wxcbObject
  }

  isNoReady () {
    return this.status === 'noReady'
  }

  isSuccess () {
    return this.status === 'success'
  }

  isCancel () {
    return this.status === 'cancel'
  }

  isError () {
    return this.status === 'error'
  }

  toString () {
    return `[${this.status}] - (${this.message}) ${this.value ? JSON.stringify(this.value) : ''}`
  }
}

export class WxWrapper {
  static shareApiList = [
    'onMenuShareTimeline',
    'onMenuShareAppMessage',
    'onMenuShareQQ',
    'onMenuShareQZone'
  ]

  static newShareApiList = [
    'updateAppMessageShareData',
    'updateTimelineShareData'
  ]

  constructor () {
    this.isReady = false
  }

  checkWxReady () {
    if (!this.isReady) {
      window.Vue.$log.warn('wx sdk is not ready')
    }
    return this.isReady
  }

  config () {
    let config = {
      debug: false,
      appId: '',
      timestamp: 0,
      nonceStr: '',
      signature: '',
      url: '',
      jsApiList: [
        'checkJsApi',
        'onMenuShareWeibo',
        'hideMenuItems',
        'showMenuItems',
        'hideAllNonBaseMenuItem',
        'showAllNonBaseMenuItem',
        'translateVoice',
        'startRecord',
        'stopRecord',
        'onVoiceRecordEnd',
        'playVoice',
        'onVoicePlayEnd',
        'pauseVoice',
        'stopVoice',
        'uploadVoice',
        'downloadVoice',
        'chooseImage',
        'previewImage',
        'uploadImage',
        'downloadImage',
        'getNetworkType',
        'openLocation',
        'getLocation',
        'hideOptionMenu',
        'showOptionMenu',
        'closeWindow',
        'scanQRCode',
        'chooseWXPay',
        'getLocalImgData',
        'openProductSpecificView',
        'addCard',
        'chooseCard',
        'openCard'
      ]}
    if (userAgentUtil.wechatVersion() >= '6.7.2') {
      config.jsApiList = config.jsApiList.concat(WxWrapper.newShareApiList)
    } else {
      config.jsApiList = config.jsApiList.concat(WxWrapper.shareApiList)
    }
    return this.asyncConfig(config)
  }

  asyncConfig (config) {
    let _wxWrapper = this
    return new Promise((resolve, reject) => {
      if (_wxWrapper.checkWxReady()) {
        resolve('alread config')
        return
      }
      let api = window.Vue.$apiUtil.getMisBuyerApi()

      api.wxjsGetApiSignature(`{"url": "${window.location.href.split('#')[0]}"}`).then((data) => {
        let _wxWrapper = this
        window.wx.ready(function () {
          _wxWrapper.isReady = true
          window.Vue.$log.log('wxWrapper is ready')
          resolve('config success')
        })
        window.wx.error(function (res) {
          window.Vue.$log.log('wxWrapper config error: ' + JSON.stringify(res))
          reject(new Error('config error'))
        })
        let sigJson = JSON.parse(data['sigJson'])
        Object.assign(config, sigJson)
        window.Vue.$log.log('before wx config ' + JSON.stringify(config))
        window.wx.config(config)
      }).catch((error) => {
        window.Vue.$log.error('wxjsGetApiSignature failed: ' + error)
      })
    })
  }

  addCard (cardId) {
    let _wxWrapper = this
    return new Promise(function (resolve, reject) {
      if (!_wxWrapper.checkWxReady()) {
        reject(WxCallbackObject.getNoReady())
      }
      let api = window.Vue.$apiUtil.getMisBuyerApi()
      api.wxjsGetCardSignature(`{"card_id": "${cardId}"}`).then((data) => {
        let ext = JSON.parse(data['sigJson'])
        let cardExt = {}
        cardExt.timestamp = ext['timestamp']
        cardExt.nonce_str = ext['nonce_str']
        cardExt.signature = ext['signature']
        cardExt.outer_str = 'app'
        let cardParams = {
          cardList: [
            {
              cardId: cardId,
              cardExt: JSON.stringify(cardExt)
            }
          ],
          success: function (res) {
            window.Vue.$log.log('addCard success: ' + JSON.stringify(res))
            resolve(WxCallbackObject.getSuccess(res, '添加卡片成功'))
          },
          cancel: function (res) {
            window.Vue.$log.warn('addCard cancel: ' + JSON.stringify(res))
            resolve(WxCallbackObject.getCancel(res, '取消添加卡片'))
          }
        }
        window.wx.addCard(cardParams)
      }).catch((error) => {
        window.Vue.$log.error('addCard failed: ' + error)
        reject(WxCallbackObject.getError(error, '添加卡片失败'))
      })
    })
  }

  async getAuthorizeCode (store) {
    if (!userAgentUtil.isWechat() || isDev || isPre) {
      return false
    }

    this._wxAuthorize(store)
    return true
  }

  async _wxAuthorize (store) {
    let config = await store.dispatch('getConfig')
    let appid = config.appid
    CacheUtil.setRedirectUrl(window.location.hash)
    // appid = 'wx523a9946d8542405'
    let baseUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?'
    // uweb.trackPageview(baseUrl, `isDev: ${isDev}, isPre: ${isPre}, href: ${window.location.href}`)
    let redirectUrl = encodeURIComponent(window.location.href)
    // let data = `appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_base&state=mi2capp#wechat_redirect`
    let data = `appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo&state=mi2capp#wechat_redirect`
    // let responseJson = fetch(url + data)
    // console.log('responseJson: ' + responseJson)
    window.location.href = `${baseUrl}${data}`
  }

  checkWxAuthorise (url, store, isRedirect = false) {
    if (store.getters.isLogin && store.state.openid) {
      userAgentUtil.isWechat() && store.dispatch('updateWxOpenid')
      return false
    }
    if (store.state.isGetWxCode || CacheUtil.getIsLogout()) {
      return false
    }
    let params = getUrlParams(url)
    if (params.code && params.state === 'mi2capp') {
      store.commit(MutationTypes.SET_GET_WXCODE_STATUS, true)
      window.Vue.$log.log('wx code ' + params.code)
      // this.getOpenid(params.code, store)
      // let hash = CacheUtil.getRedirectUrl()
      // if (hash) {
      //   window.location.hash = hash
      // }
      this.loginByWxCode(params.code, store)
      return true
    } else if (isRedirect) {
      if (!userAgentUtil.isWechat() || isDev || isPre) {
        this.getOpenidByUserInfo(store)
        return false
      }
      return this.getAuthorizeCode(store)
    }
    return false
  }

  getOpenidByUserInfo (store) {
    if (!store.getters.isLogin) {
      return
    }
    let api = window.Vue.$apiUtil.getLoginApi()
    api.getUser().then((data) => {
      store.commit(MutationTypes.SET_GET_WXCODE_STATUS, true)
      store.commit(MutationTypes.SET_OPENID, data.user.wx_openid)
    }).catch((error) => {
      window.Vue.$log.error('getUserInfo failed: ' + error)
    })
  }

  loginByWxCode (code, store) {
    let api = window.Vue.$apiUtil.getLoginApi()
    api.loginByWxCode(code).then((data) => {
      store.commit(MutationTypes.SET_OPENID, data.user.wx_openid)
      if (data.user.userid > 0) {
        store.commit(MutationTypes.SET_USEROAUTH, data.oauth)
        store.commit(MutationTypes.SET_USERINFO, data.user)
      } else {
        CacheUtil.setWxUserInfo(data.user)
      }

      let hash = CacheUtil.getRedirectUrl()
      if (hash) {
        window.location.hash = hash
      }
    }).catch((error) => {
      window.Vue.$log.error('loginByWxCode failed: ' + error)
    })
  }

  getOpenid (code, store) {
    let api = window.Vue.$apiUtil.getMisBuyerApi()
    api.getWxAcccessToken(code).then((data) => {
      store.commit(MutationTypes.SET_OPENID, data.wxOauth.openid)
      store.dispatch('updateWxOpenid')
    }).catch((error) => {
      window.Vue.$log.error('getWxAcccessToken failed: ' + error)
    })
  }

  wxPay (payInfo) {
    let _wxWrapper = this
    return new Promise(function (resolve, reject) {
      if (!_wxWrapper.checkWxReady()) {
        reject(WxCallbackObject.getNoReady())
      }
      window.wx.chooseWXPay({
        timestamp: payInfo.timestamp,
        nonceStr: payInfo.nonceStr,
        package: payInfo.package,
        signType: payInfo.signType,
        paySign: payInfo.paySign,
        success: function (res) {
          window.Vue.$log.log('wxPay success: ' + JSON.stringify(res))
          resolve(WxCallbackObject.getSuccess(res, '支付成功'))
        },
        cancel: function (res) {
          resolve(WxCallbackObject.getCancel(res, '取消支付'))
        }
      })
    })
  }

  closeWindow () {
    if (!this.checkWxReady()) {
      return
    }
    window.wx.closeWindow()
  }

  scanQRCode (type = ['qrCode', 'barCode']) {
    let _wxWrapper = this
    return new Promise((resolve, reject) => {
      if (!_wxWrapper.checkWxReady()) {
        reject(WxCallbackObject.getNoReady())
      }
      window.wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: type, // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
          var result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
          resolve(result)
        }
      })
    })
  }

  async updateShareData (title, desc, link, imgUrl) {
    try {
      console.log('before await config')
      await this.config()
      if (!this.checkWxReady()) {
        console.log('await config cannot ready')
      }
    } catch (error) {
      return false
    }
    let _wxWrapper = this
    return new Promise((resolve, reject) => {
      if (!_wxWrapper.checkWxReady()) {
        reject(WxCallbackObject.getNoReady())
      }
      let updateShareAppMessage = window.wx.onMenuShareAppMessage
      if (userAgentUtil.wechatVersion() >= '6.7.2') {
        updateShareAppMessage = window.wx.updateAppMessageShareData
      }
      updateShareAppMessage({
        title: title, // 分享标题
        desc: desc, // 分享描述
        link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: imgUrl, // 分享图标
        success: function () {
          resolve('success')
        }
      })
    })
  }

  chooseImage () {
    let _wxWrapper = this
    return new Promise((resolve, reject) => {
      if (!_wxWrapper.checkWxReady()) {
        reject(WxCallbackObject.getNoReady())
      }
      window.wx.chooseImage({
        count: 1, // 默认9
        sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有 'original' 'compressed',
        sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
        success: function (res) {
          var localIds = res.localIds // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
          resolve(localIds)
        }
      })
    })
  }

  // 此接口仅在 iOS WKWebview 下提供，用于兼容 iOS WKWebview 不支持 localId 直接显示图片的问题.
  getLocalImgData (localId, vm) {
    let _wxWrapper = this
    return new Promise((resolve, reject) => {
      if (!_wxWrapper.checkWxReady()) {
        reject(WxCallbackObject.getNoReady())
      }

      window.wx.getLocalImgData({
        localId: localId, // 图片的localID
        success: function (res) {
          var localData = res.localData // localData是图片的base64数据，可以用img标签显示
          delete res['localData']
          console.log('getLocalImgData res: ' + JSON.stringify(res))
          resolve(localData)
        },
        fail: function (res) {
          vm.$dialog.alert({message: 'getLocalImgData fail: ' + res.errMsg})
        }
      })
    })
  }

  getLocation () {
    let _wxWrapper = this
    return new Promise((resolve, reject) => {
      if (!_wxWrapper.checkWxReady()) {
        reject(WxCallbackObject.getNoReady())
      }

      window.wx.getLocation({
        success: function (res) {
          var position = res
          resolve(position)
        },
        fail: function (res) {
          resolve('用户拒绝访问位置')
        }
      })
    })
  }
}

let wxWrapper = new WxWrapper()
export default wxWrapper



// WEBPACK FOOTER //
// ./src/wxapi/WxWrapper.js